import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
export function FinalCTASection() {
  return <section id="visita" className="bg-navy text-white py-16 md:py-24 relative overflow-hidden" data-id="element-23">
      <div className="absolute top-0 right-0 w-64 h-64 bg-gold opacity-5 rounded-full -translate-y-1/2 translate-x-1/2" data-id="element-24"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold opacity-5 rounded-full translate-y-1/2 -translate-x-1/2" data-id="element-25"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-27">
          <div className="w-16 h-1 bg-gold mx-auto mb-6" data-id="element-28"></div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold mb-6" data-id="element-29">
            Tu negocio merece mejores condiciones
          </h2>
          <p className="text-lg md:text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-30">
            No te pedimos que cambies sin razón. Primero analizamos tu situación
            actual y solo te presentamos una propuesta si realmente podemos
            ayudarte a ahorrar o mejorar tu servicio.
          </p>
          <Link to="/contacto" className="inline-block bg-gold text-navy px-10 py-5 rounded-md font-bold text-lg hover:bg-opacity-90 transition-all shadow-2xl" data-id="element-31">
            Solicita tu evaluación gratuita
          </Link>
          <p className="text-sm text-gray-400 mt-6" data-id="element-32">
            Sin compromiso • Análisis gratuito • Respuesta en 24-48 horas
          </p>
        </motion.div>
      </div>
    </section>;
}